/* eslint-disable max-len */
import React from 'react';

const UnauthorizedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
	return (
		<svg
			width="49"
			height="49"
			viewBox="0 0 49 49"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M24.5 0C38.031 0 49 10.969 49 24.5C49 38.031 38.031 49 24.5 49C10.969 49 0 38.031 0 24.5C0 10.969 10.969 0 24.5 0ZM8.35352 39.9355C12.4204 44.1886 18.1506 46.8379 24.5 46.8379C36.8371 46.8379 46.8379 36.8371 46.8379 24.5C46.8379 19.5744 45.2425 15.0221 42.542 11.3291L8.35352 39.9355ZM24.5 2.16211C12.1629 2.16211 2.16211 12.1629 2.16211 24.5C2.16211 29.4091 3.74663 33.9474 6.43066 37.6338L40.6143 9.03125C36.5493 4.79773 30.8327 2.16211 24.5 2.16211Z" fill="#F52D2D"/>
			<path d="M34.3994 20.416C34.5132 20.8222 34.5722 21.2947 34.5723 21.8369V33.5068C34.5723 35.8113 33.5672 36.8574 31.5273 36.8574H17.0293C16.3037 36.8574 15.7093 36.7219 15.2451 36.4434L34.3994 20.416ZM24.2783 6C27.9092 6.00001 31.4063 8.39293 31.9775 13.3154L29.001 15.8066V14.4824C29.0009 11.0013 26.8673 9.07326 24.2783 9.07324C21.6893 9.07324 19.5714 11.0013 19.5713 14.4824V18.5195L25.7725 18.5078L14 28.3594V21.8369C14.0001 19.8597 14.9262 18.8136 16.5107 18.5684V14.7607C16.5107 8.86062 20.3084 6 24.2783 6Z" fill="#2C305E"/>
		</svg>
	);
}

export default UnauthorizedIcon;